{
  "name": "guidozorn-dev",
  "version": "0.0.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build-local": "ng build --configuration local",
    "build-dev": "ng build --configuration development",
    "build-prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration local",
    "test": "ng test",
    "deploy-dev": "firebase use development && firebase deploy --only hosting:guidozorn-dev-admin",
    "deploy-prod": "firebase use production && firebase deploy --only hosting:guidozorn-admin",
    "build-deploy-dev": "npm run build-dev && npm run deploy-dev",
    "build-deploy-prod": "npm run build-prod && npm run deploy-prod",
    "release": "standard-version"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.0",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/fire": "^17.1.0",
    "@angular/forms": "^17.3.0",
    "@angular/material": "^17.3.10",
    "@angular/platform-browser": "^17.3.0",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@angular/service-worker": "^17.3.0",
    "firebase": "^10.14.1",
    "firebaseui": "^6.1.0",
    "firebaseui-angular": "^6.3.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.0.5",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.5",
    "@angular/cli": "^17.3.5",
    "@angular/compiler-cli": "^17.3.0",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^22.10.5",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "standard-version": "^9.5.0",
    "typescript": "~5.4.2"
  }
}
